class ProductSizes extends HTMLElement {
  constructor() {
    super();
    this.showSizesBtn = this.querySelector(".js-open-size-selector");
    this.sizeContainer = this.querySelector(".grid-item-custom__size-selectors");
    this.sizeAtcBtns = this.querySelectorAll(".grid-item-custom__size-swatch");
    this.initEvtListeners();
  }
  initEvtListeners() {
    if (this.showSizesBtn) {
      this.showSizesBtn.addEventListener("click", (e) => {
        if (e.target.dataset.open === "true") {
          this.sizeContainer.classList.add("hidden");
          e.target.setAttribute("data-open", "false");
        } else {
          this.sizeContainer.classList.remove("hidden");
          e.target.setAttribute("data-open", "true");
        }
      });
    }
    this.addSizeEventListener();
    window.addEventListener("searchspring.domReady", this.initAfterSearchspringLoads.bind(this));
    window.addEventListener("searchspringCarousel.domReady", this.initAfterSearchspringLoads.bind(this));
  }
  initAfterSearchspringLoads() {
    this.showSizesBtn = this.querySelector(".js-open-size-selector");
    this.sizeAtcBtns = this.querySelectorAll(".grid-item-custom__size-swatch");
    this.sizeContainer = this.querySelector(".grid-item-custom__size-selectors");
    this.addSizeEventListener();
  }
  addSizeEventListener() {
    if (this.sizeAtcBtns.length) {
      this.sizeAtcBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const id = e.target.dataset.id;
          this.addProductToCart(e.target, id);
        });
      });
    }
  }
  async addProductToCart(btn, id) {
    btn.classList.add("btn--loading");
    try {
      const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      });
      const data = await res.json();
      if (res.ok) {
        // document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
        //   detail: { product: data }
        // }));
        var url = window.location.href;
        if(url.indexOf('/cart') > -1){
          window.location.href = '/cart' 
        }else{
          opusOpen(); 
        }
      }
      if (res.status === 422) {
        this.error(data);
      }
    } catch (error) {
      this.error(error);
    } finally {
      btn.classList.remove("btn--loading");
      this.sizeContainer.classList.add("hidden");
      this.showSizesBtn.setAttribute("data-open", "false");
    }
  }
  static get observedAttributes() {
    return ["data-product"];
  }
  attributeChangedCallback() {
    this.initAfterSearchspringLoads();
  }
}

customElements.get("product-sizes") || customElements.define("product-sizes", ProductSizes);
